/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-05 10:17:42
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-03-05 10:25:04
 * @Description: file content
 */
import { useEffect } from 'react';

var useTitle = function useTitle(title) {
  useEffect(function () {
    document.title = title;
    return function () {
      document.title = "\u200E";
    };
  }, [title]);
};

export default useTitle;